import { CLASSROOM_EXPORT_MATERIAL_SECTIONS } from '../../constants/endpoints';
import request, { getData } from './request';

const exportSections = async (classRoomId, educatorOnly) => {
  const apiUrl = CLASSROOM_EXPORT_MATERIAL_SECTIONS(classRoomId, educatorOnly);
  const { url } = await request({ method: 'get', url: apiUrl }).then(getData);
  return url;
};

export default exportSections;
